
import config from '../constants/Config';

const BootState = function() {

  this.isActive = false;

};

BootState.prototype = {
    
  constructor: BootState,

  init: function() {


  },

  preload: function() {
    
    // currently in the boot state
    this.isActive = true;

    // load preloader elements
    var imageFolder = config.imageFolder;

    // atlases
    this.game.load.atlasJSONHash('loading',
      require(`../../${config.imageFolder}/skeeLoading.png`),
      require(`file?name=data/[name].[hash].json!../../${config.imageFolder}/skeeLoading.json`));

    // color
    this.game.stage.backgroundColor = 0xffffff;

    // listen for size/orientation changes
    this.game.scale.onSizeChange.add(this.draw, this);
    this.game.scale.onOrientationChange.add(this._checkOrientation, this);

    // setup size manager
    this.game.sizeManager.scaleManagerReady();

  },

  create: function() {

    // initial resize
    this.game.sizeManager.resizeGame();

    // pwd
    if (config.protect && !this._authorize()) {
      return;
    }

    if (config.debug) {

      // This is the phaser-debug plugin used in Fortune Dice
      //this.game.add.plugin(Phaser.Plugin.Debug);


    }

    // add-on
    this.game.time.elapsedSeconds = 0;

    // 30 fps on mobile
    if (!this.game.device.desktop) {
      //this.game.time.desiredFps = 30;
    }

    // force landscape
    this._checkOrientation();

    // exit
    this.game.state.start('PreloaderState');

  },

  shutdown: function() {

    this.isActive = false;

  },

  draw: function() {

  },

  _checkOrientation: function() {

    // show/hide 
    var blocker = document.getElementsByClassName('blocker')[0];
    var display = (this.game.sizeManager.isPortrait) ? 'block' : 'none';

    if (blocker) {
      blocker.style.display = display;
    }


  },

  _authorize: function() {

    var tries = 3;
    var tickle = prompt(':::::::::::::','');

    while (tries > 0) {
      
      if (!tickle) {
        history.go(-1);  
      }
      
      if (tickle === 'FD!pixl0' || tickle === '1234') {
        return true;
      }

      tries--;
      tickle = prompt('Try again.','');
    }

    return false;

  }


};

export default BootState;


// WEBPACK FOOTER //
// ./app/src/states/BootState.js